import {
  Box,
  BoxProps,
  Divider,
  HStack,
  StackProps,
  Text,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { CherryHubAdminApi } from "../../api/adminApiModels";
import { UnitOfTimeList } from "../../enums/UnitOfTime";
import { IntegerField } from "../fields/IntegerField/IntegerField";
import { ChakraReactSelectField } from "../fields/SelectField/ChakraReactSelectField";

interface TimePeriodProps {
  headerLabel: string;
  fieldName: string;
  timePeriod: CherryHubAdminApi.TimePeriod | undefined;
  isRelativeListbox?: boolean;
  quantityValueProps?: StackProps;
  periodValueProps?: StackProps;
  isDisabled?: boolean;
}

export const TimePeriod = ({
  headerLabel,
  fieldName,
  timePeriod,
  isRelativeListbox,
  quantityValueProps,
  periodValueProps,
  isDisabled,
  ...props
}: TimePeriodProps & BoxProps) => {
  const unitOfTimeOptions = UnitOfTimeList();

  const view = useMemo(() => {
    return (
      <Box
        w="100%"
        p={4}
        border="1px solid"
        borderColor="cherryButtonDark.50"
        borderRadius="md"
        {...props}
      >
        <Text fontSize="sm">
          <b>{headerLabel}</b> :
        </Text>
        <Divider mb={2} />

        <HStack w="100%" spacing={4} alignItems="flex-start">
          <IntegerField
            horizontal
            valueProps={quantityValueProps}
            label="Quantity"
            name={`${fieldName}.Quantity`}
            isDisabled={isDisabled}
          />

          <ChakraReactSelectField
            horizontal
            allowEmpty
            valueProps={periodValueProps}
            label="Period"
            name={`${fieldName}.Period`}
            selectedOptionColor="blue"
            options={unitOfTimeOptions}
            className={isRelativeListbox ? "relative-listbox" : ""}
            isDisabled={isDisabled}
          />
        </HStack>
      </Box>
    );
  }, [timePeriod, isDisabled]);

  return <>{view}</>;
};
